import withSuspense from 'es/core/hocs/withSuspense';
import { useI18n } from 'es/core/hooks/useI18n';
import React from 'react';

const ReturnHome = () => {
    const { l10n } = useI18n('app/components', 'error');
    return (
        <a className="return-home" href="/">
            {l10n('returnHome')}
        </a>
    );
};

export default withSuspense(ReturnHome);
